// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../common/Components/IconV5.bs.js");
let Spinner = require("../../common/Components/Spinner.bs.js");
let Tooltip = require("../../common/Components/Tooltip.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormRelay__Validators = require("./PropertyWizardFormRelay__Validators.bs.js");
let PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.bs.js");
let PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.bs.js");

function PropertyWizardRelay__Preview__GlobalValidityIndicator$ShareDraftButton(props) {
  let __size = props.size;
  let __showDisabledHint = props.showDisabledHint;
  let disabled = props.disabled;
  let onShareDraft = props.onShareDraft;
  let showDisabledHint = __showDisabledHint !== undefined ? __showDisabledHint : false;
  let size = __size !== undefined ? __size : "medium";
  let button = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
    onClick: param => onShareDraft(),
    disabled: disabled,
    size: size,
    icon: "share",
    children: "Share draft"
  });
  if (showDisabledHint && disabled) {
    return JsxRuntime.jsx(Tooltip.make, {
      label: "Only valid drafts can be shared",
      children: JsxRuntime.jsx("span", {
        children: button,
        className: "inline-flex"
      })
    });
  } else {
    return button;
  }
}

let ShareDraftButton = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$ShareDraftButton
};

let convertFragment = PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftAttachmentStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftAttachmentStatus_decode;

let FormStateFragment_localDraftAttachmentStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftAttachmentStatus_fromString;

let FormStateFragment_localDraftSaveStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftSaveStatus_decode;

let FormStateFragment_localDraftSaveStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftSaveStatus_fromString;

let FormStateFragment_localGeocodingStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localGeocodingStatus_decode;

let FormStateFragment_localGeocodingStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localGeocodingStatus_fromString;

let FormStateFragment = {
  localDraftAttachmentStatus_decode: FormStateFragment_localDraftAttachmentStatus_decode,
  localDraftAttachmentStatus_fromString: FormStateFragment_localDraftAttachmentStatus_fromString,
  localDraftSaveStatus_decode: FormStateFragment_localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: FormStateFragment_localDraftSaveStatus_fromString,
  localGeocodingStatus_decode: FormStateFragment_localGeocodingStatus_decode,
  localGeocodingStatus_fromString: FormStateFragment_localGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator$ActionButtons(props) {
  let onSubmit = props.onSubmit;
  let __className = props.className;
  let size = props.size;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsxs("div", {
    children: [
      props.showShareDraft ? JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$ShareDraftButton, {
          onShareDraft: props.onShareDraft,
          disabled: props.shareDraftDisabled,
          showDisabledHint: props.shareDraftInvalid,
          size: size
        }) : null,
      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
        onClick: param => onSubmit(),
        disabled: props.submitDisabled,
        size: size,
        icon: props.submitIcon,
        children: props.submitLabel
      })
    ],
    className: TailwindMerge.twMerge([
      "flex flex-wrap items-center gap-4",
      className
    ])
  });
}

let ActionButtons = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$ActionButtons
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator$Display(props) {
  let onShareDraft = props.onShareDraft;
  let onSubmit = props.onSubmit;
  let onEditForm = props.onEditForm;
  let __shareDraftInvalid = props.shareDraftInvalid;
  let __shareDraftDisabled = props.shareDraftDisabled;
  let __showShareDraft = props.showShareDraft;
  let __submitDisabled = props.submitDisabled;
  let submitIcon = props.submitIcon;
  let submitLabel = props.submitLabel;
  let __editLabel = props.editLabel;
  let statusVariant = props.statusVariant;
  let editLabel = __editLabel !== undefined ? __editLabel : "Continue editing";
  let submitDisabled = __submitDisabled !== undefined ? __submitDisabled : false;
  let showShareDraft = __showShareDraft !== undefined ? __showShareDraft : true;
  let shareDraftDisabled = __shareDraftDisabled !== undefined ? __shareDraftDisabled : false;
  let shareDraftInvalid = __shareDraftInvalid !== undefined ? __shareDraftInvalid : false;
  let tmp;
  switch (statusVariant) {
    case "Neutral" :
    case "Loading" :
      tmp = "bg-tan-gold-light text-white";
      break;
    case "Attention" :
      tmp = "bg-red-500 text-white";
      break;
  }
  let iconWrapperClasses = TailwindMerge.twMerge([
    "size-9 rounded-md flex items-center justify-center shrink-0",
    tmp
  ]);
  let bottomBorderToneClasses;
  switch (statusVariant) {
    case "Neutral" :
    case "Loading" :
      bottomBorderToneClasses = "border-b-tan-gold-light";
      break;
    case "Attention" :
      bottomBorderToneClasses = "border-b-red-500";
      break;
  }
  let backgroundColor;
  switch (statusVariant) {
    case "Neutral" :
    case "Loading" :
      backgroundColor = "bg-[#f7f1e5]";
      break;
    case "Attention" :
      backgroundColor = "bg-red-100";
      break;
  }
  let statusIcon;
  switch (statusVariant) {
    case "Neutral" :
      statusIcon = JsxRuntime.jsx(IconV5.make, {
        icon: "eye",
        size: 18
      });
      break;
    case "Loading" :
      statusIcon = JsxRuntime.jsx(Spinner.make, {
        size: 18,
        stroke: "white"
      });
      break;
    case "Attention" :
      statusIcon = JsxRuntime.jsx(IconV5.make, {
        icon: "attention-alt",
        size: 18
      });
      break;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs(ButtonsV5.LinkButton.make, {
              onClick: param => onEditForm(),
              size: "medium",
              className: "flex gap-1 items-center text-sm font-semibold ",
              children: [
                JsxRuntime.jsx(IconV5.make, {
                  icon: "arrow-left",
                  size: 12
                }),
                editLabel
              ]
            }),
            className: "lg:hidden"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: statusIcon,
                    className: iconWrapperClasses
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        children: props.statusTitle,
                        className: "text-zinc-800 font-semibold leading-5"
                      }),
                      JsxRuntime.jsx("div", {
                        children: props.statusDescription,
                        className: "text-zinc-600 text-sm leading-5"
                      })
                    ],
                    className: "min-w-0"
                  })
                ],
                className: "flex items-center gap-3 min-w-0"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                    onClick: param => onEditForm(),
                    size: "medium",
                    className: "hidden lg:inline-flex font-semibold",
                    children: editLabel
                  }),
                  JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$ActionButtons, {
                    size: "small",
                    className: "lg:pl-4 lg:border-l lg:hidden",
                    showShareDraft: showShareDraft,
                    shareDraftDisabled: shareDraftDisabled,
                    shareDraftInvalid: shareDraftInvalid,
                    submitDisabled: submitDisabled,
                    submitLabel: submitLabel,
                    submitIcon: submitIcon,
                    onSubmit: onSubmit,
                    onShareDraft: onShareDraft
                  }),
                  JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$ActionButtons, {
                    size: "medium",
                    className: "lg:pl-4 lg:border-l hidden lg:flex",
                    showShareDraft: showShareDraft,
                    shareDraftDisabled: shareDraftDisabled,
                    shareDraftInvalid: shareDraftInvalid,
                    submitDisabled: submitDisabled,
                    submitLabel: submitLabel,
                    submitIcon: submitIcon,
                    onSubmit: onSubmit,
                    onShareDraft: onShareDraft
                  })
                ],
                className: "flex flex-wrap items-center gap-4 md:justify-end"
              })
            ],
            className: "flex flex-col gap-4 md:flex-row md:items-center md:justify-between"
          })
        ],
        className: "flex flex-col gap-4"
      }),
      className: "max-w-full md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px] mx-auto px-4 py-3"
    }),
    className: TailwindMerge.twMerge([
      "border-b-2",
      backgroundColor,
      bottomBorderToneClasses
    ])
  });
}

let Display = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$Display
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator(props) {
  let currentStep = props.currentStep;
  let onEditForm = props.onEditForm;
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, props.formState);
  let geocodingStatus = formState.geocodingStatus;
  let draftSaveStatus = formState.draftSaveStatus;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, props.draft);
  let formValid = PropertyWizardFormRelay__Validators.useIsFormValid(draft.fragmentRefs, formState.fragmentRefs);
  let formIsValid = Stdlib_Result.isOk(formValid);
  let sharedDraftsEnabled = FeaturesV3.useFeatureFlipper("SharedPropertyDrafts") === "on";
  let editCurrentStep = () => {
    if (formValid.TAG === "Ok") {
      return onEditForm(currentStep);
    } else {
      return onEditForm(formValid._0);
    }
  };
  let draftSubmitting;
  switch (draftSaveStatus) {
    case "FirstSaveInProgress" :
    case "SaveInProgress" :
      draftSubmitting = true;
      break;
    default:
      draftSubmitting = false;
  }
  let submitting = draftSubmitting || props.isSubmittingForm;
  let hasUploadingAttachments = formState.filesStatus.length !== 0 || formState.imagesStatus.length !== 0;
  let geocodingInProgress = geocodingStatus === "Called";
  let hasDuplicateAddress = geocodingStatus === "ErrorDuplicateListing";
  let saveFailed = draftSaveStatus === "SaveFailed";
  let hasSavedDraft = Stdlib_Option.isSome(draft.serverDraftId);
  let shareDraftDisabled = !formIsValid || !hasSavedDraft || submitting;
  let shareDraftInvalid = !formIsValid;
  let submitDisabled = hasUploadingAttachments || geocodingInProgress || hasDuplicateAddress || !formIsValid || submitting;
  let match$1;
  if (typeof mode !== "object") {
    match$1 = [
      "Broadcast",
      "megaphone-alt"
    ];
  } else {
    switch (mode.TAG) {
      case "Edit" :
        match$1 = [
          "Save Changes",
          undefined
        ];
        break;
      case "Rebroadcast" :
        match$1 = [
          "Rebroadcast",
          "megaphone-alt"
        ];
        break;
      case "BroadcastQuietSeller" :
        match$1 = [
          "Broadcast",
          "megaphone-alt"
        ];
        break;
    }
  }
  let showShareDraft;
  showShareDraft = typeof mode !== "object" || mode.TAG !== "Edit" ? sharedDraftsEnabled : false;
  let match$2;
  if (hasUploadingAttachments) {
    match$2 = [
      "Loading",
      "Your attachments are being uploaded",
      "Please wait...",
      "Continue editing"
    ];
  } else if (geocodingInProgress) {
    match$2 = [
      "Loading",
      "The address is being validated",
      "Please wait...",
      "Continue editing"
    ];
  } else if (hasDuplicateAddress) {
    match$2 = [
      "Attention",
      "This property is already on TAN",
      "Please go back and check the address.",
      "Edit address"
    ];
  } else if (formIsValid) {
    if (draftSubmitting) {
      match$2 = [
        "Loading",
        "Preview — saving your draft...",
        "Please wait...",
        "Continue editing"
      ];
    } else if (saveFailed) {
      match$2 = [
        "Attention",
        "Preview — your draft could not be saved",
        "You can continue editing but may lose progress.",
        "Continue editing"
      ];
    } else {
      let match$3;
      if (typeof mode !== "object") {
        match$3 = [
          "You're previewing your draft",
          "This property hasn't been broadcast yet."
        ];
      } else {
        switch (mode.TAG) {
          case "Edit" :
            match$3 = [
              "You're previewing your property updates",
              ""
            ];
            break;
          case "Rebroadcast" :
            match$3 = [
              "You're previewing your rebroadcast",
              ""
            ];
            break;
          case "BroadcastQuietSeller" :
            match$3 = [
              "You're previewing your draft",
              "This property hasn't been broadcast yet."
            ];
            break;
        }
      }
      match$2 = [
        "Neutral",
        match$3[0],
        match$3[1],
        "Continue editing"
      ];
    }
  } else {
    match$2 = [
      "Attention",
      "Some required fields are missing or invalid",
      "Please review and correct the highlighted fields.",
      "Continue editing"
    ];
  }
  return JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$Display, {
    statusVariant: match$2[0],
    statusTitle: match$2[1],
    statusDescription: match$2[2],
    editLabel: match$2[3],
    submitLabel: match$1[0],
    submitIcon: match$1[1],
    submitDisabled: submitDisabled,
    showShareDraft: showShareDraft,
    shareDraftDisabled: shareDraftDisabled,
    shareDraftInvalid: shareDraftInvalid,
    onEditForm: editCurrentStep,
    onSubmit: props.onSubmit,
    onShareDraft: props.onShareDraft
  });
}

let make = PropertyWizardRelay__Preview__GlobalValidityIndicator;

exports.ShareDraftButton = ShareDraftButton;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.ActionButtons = ActionButtons;
exports.Display = Display;
exports.make = make;
/* IconV5 Not a pure module */
